module.exports = __webpack_public_path__ + "media/images/index-hero-badge-my-b80fd8ce9023d64f00a5997a6a42dffd.svg";